import React from "react";
import styled from "styled-components";
import media from "styled-media-query";

// API
import { useInView } from "react-intersection-observer";

// Styles
import { getFontWeight } from "../../../styles/font-weight";

// Parts
import { SectionTitle } from "./SectionTitle";

export const HowMade = () => {
  const [ref1, inView1] = useInView({
    rootMargin: "-100px 0px",
  });

  const [ref2, inView2] = useInView({
    rootMargin: "-80px 0px",
  });

  return (
    <StyledDivRootContainer>
      <SectionTitle title="How It's Made" />
      <StyledDivMovingToRightContainer ref={ref1} id="first-container" className={inView1 ? "visible" : ""}>
        <StyledDivHandMade>
          <StyledDivPictureFirst src={require("../../../assets/images/handmade.png")} />
          <StyledDivSentenceLeftMargin>Each piece is made by hand without using any molds.</StyledDivSentenceLeftMargin>
        </StyledDivHandMade>
      </StyledDivMovingToRightContainer>

      <StyledDivWhiteBox />

      <StyledDivMovingToLeftContainer ref={ref2} className={inView2 ? "visible" : ""}>
        <StyledDivCutEdge>
          <StyledDivSentenceRightMargin>
            It takes a week for the whole process to condense the flavor.
          </StyledDivSentenceRightMargin>
          <StyledDivPictureSecond src={require("../../../assets/images/pcs-array.png")} />
        </StyledDivCutEdge>
      </StyledDivMovingToLeftContainer>
    </StyledDivRootContainer>
  );
};

const StyledDivRootContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  height: 420px;

  ${media.greaterThan("medium")`
    height: 700px;
  `};

  ${media.greaterThan("large")`
    height: 800px;
  `};

  ${media.greaterThan("huge")`
    height: 900px;
  `}
`;

const StyledDivSentenceLeftMargin = styled.div`
  width: 35%;
  font-size: 14px;
  line-height: 16px;
  margin-left: 8px;
  margin-right: 8xpx;
  ${getFontWeight("Light")};

  ${media.greaterThan("medium")`
    font-size: 32px;
    line-height: 32px;
  `};
`;

const StyledDivSentenceRightMargin = styled.div`
  width: 35%;
  font-size: 14px;
  line-height: 16px;
  margin-left: 8px;
  margin-right: 8xpx;
  ${getFontWeight("Light")};

  ${media.greaterThan("medium")`
    font-size: 32px;
    line-height: 32px;
  `};
`;

const StyledDivPictureFirst = styled.img`
  width: 60vw;

  ${media.greaterThan("medium")`
    width: 30vw;
  `};
`;

const StyledDivPictureSecond = styled.img`
  width: 60vw;

  ${media.greaterThan("medium")`
    width: 30vw;
`};
`;

const StyledDivHandMade = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const StyledDivCutEdge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const StyledDivWhiteBox = styled.div`
  width: 100%;
  height: 36px;
`;

const StyledDivMovingToRightContainer = styled.div`
  position: absolute;
  width: 100vw;

  opacity: 0;
  &.visible {
    opacity: 1;
  }

  transition: all 1500ms 0s ease;
`;

const StyledDivMovingToLeftContainer = styled.div`
  position: absolute;
  width: 100vw;
  top: 280px;

  ${media.greaterThan("medium")`
    top: 480px;
  `};

  opacity: 0;
  &.visible {
    opacity: 1;
  }

  transition: all 1500ms 0s ease;
`;
